import { render, staticRenderFns } from "./GridView.vue?vue&type=template&id=33159898&scoped=true"
import script from "./GridView.vue?vue&type=script&lang=js"
export * from "./GridView.vue?vue&type=script&lang=js"
import style0 from "./GridView.vue?vue&type=style&index=0&id=33159898&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33159898",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33159898')) {
      api.createRecord('33159898', component.options)
    } else {
      api.reload('33159898', component.options)
    }
    module.hot.accept("./GridView.vue?vue&type=template&id=33159898&scoped=true", function () {
      api.rerender('33159898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/product-list/browser/views/GridView.vue"
export default component.exports